/* eslint-disable no-undef */
export const msalConfig = {
    auth: {
        clientId: process.env.CLIENT_ID_SSO,
        authority: process.env.AUTHORITY,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: process.env.LOGOUT_URI,
        redirectStartPage: window.location.href,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: process.env.CACHE_LOCATION,
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ['User.Read'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: process.env.GRAPHME_ENDPOINT,
};
